import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

// Reviews Slider
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.reviews-slider').forEach((slider) => {
    new Swiper(slider, {
      modules: [Pagination, Autoplay],
      slidesPerView: 3,
      initialSlide: 0,
      spaceBetween: 24,
      grabCursor: true,
      autoHeight: false,
      autoplay: {
        delay: 15000,
        disableOnInteraction: false,
      },
      pagination: {
        el:
          slider.querySelector('.swiper-pagination') ||
          '.reviews-slider .swiper-pagination',
        clickable: true,
        type: 'bullets',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
      },
    });
  });
});
